import routes from "@app/config/routes";
import Features from "@app/features";
import ConsumerOutReport from "@app/features/consumerOutReport/ConsumerOutReport";
import TopInventoryOutReport from "@app/features/topInventoryOutReport/TopInventoryOutReport";
import DeliveryAuth from "@app/features/deliveryAuth/DeliveryAuth";
import DeliveryAuthDetail from "@app/features/deliveryAuth/DeliveryAuthDetail";
import DispensaryStore from "@app/features/dispensaryStore/dispensaryStore";
import DetailDispensarySupportFiles from "@app/features/dispensarySupportFiles/DetailDispensarySupportFiles";
import DispensarySupportFiles from "@app/features/dispensarySupportFiles/DispensarySupportFiles";
import Delivery from "@app/features/drugDelivery/delivery/Delivery";
import DeliveryOrderPDF from "@app/features/drugDelivery/delivery/components/DeliveryOrderPDF";
import DeliveryDetail from "@app/features/drugDelivery/delivery/detail/DeliveryDetail";
import Order from "@app/features/drugDelivery/order/Order";
import PatientOrderInformation from "@app/features/drugDelivery/order/patient/PatientOrderInformation";
import Selection from "@app/features/menu/Selection";
import PendingConsults from "@app/features/pendingConsults/PendingConsults";
import PharmacyControl from "@app/features/pharmacyControl/PharmacyControl";
import CancellationDeliveries from "@app/features/cancellationDeliveries/CancellationDeliveries";
import AccountingNotes from "@app/features/accountingNotes/AccountingNotes";
import AccountingNoteCreditDetail from "@app/features/accountingNotes/AccountingNoteCreditDetail";
import DetailSupportsConsults from "@app/features/supportsConsult/DetailSupportsConsults";
import SupportsConsult from "@app/features/supportsConsult/SupportsConsults";
import HandleUpdateSupportParameter from "@app/features/supportsParameters/HandleUpdateSupportParameter";
import SupportsParameters from "@app/features/supportsParameters/SupportsParameters";
import { createBrowserRouter } from "react-router-dom";
import Guardian from "./guardian";
import ValidateAuth from "./validate";
import EditPatient from "@app/features/drugDelivery/order/patient/EditPatient";
import RoutePermissionGuard from "./RoutePermissionGuard";

const router = createBrowserRouter([
  { path: routes.root, element: <Guardian /> },
  { path: routes.validate, element: <ValidateAuth /> },
  {
    path: routes.dispensation,
    element: <Features />,
    children: [
      {
        index: true,
        element: <Selection />
      },
      {
        path: routes.drugDelivery,
        element: (
          <RoutePermissionGuard routePath={routes.drugDelivery}>
            <Order />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getEpsOrder,
        element: (
          <RoutePermissionGuard routePath={routes.getEpsOrder}>
            <Order />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getDeliveryDispensation,
        element: (
          <RoutePermissionGuard routePath={routes.getDeliveryDispensation}>
            <Delivery />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getDeliveryDispensationDetail,
        element: (
          <RoutePermissionGuard routePath={routes.getDeliveryDispensationDetail}>
            <DeliveryDetail />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getPatientOrderInformation,
        element: (
          <RoutePermissionGuard routePath={routes.getPatientOrderInformation}>
            <PatientOrderInformation />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getPatientOrderInformationEdit,
        element: (
          <RoutePermissionGuard routePath={routes.getPatientOrderInformation}>
            <EditPatient />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getDeliveryAuth,
        element: (
          <RoutePermissionGuard routePath={routes.getDeliveryAuth}>
            <DeliveryAuth />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getDeliveryAuthDetail,
        element: (
          <RoutePermissionGuard routePath={routes.getDeliveryAuth}>
            <DeliveryAuthDetail />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getDeliveryDetailOrder,
        element: (
          <RoutePermissionGuard routePath={routes.getDeliveryDispensation}>
            <DeliveryOrderPDF />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getSupportsParameter,
        element: (
          <RoutePermissionGuard routePath={routes.getSupportsParameter}>
            <SupportsParameters />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getCreateSupportParameter,
        element: (
          <RoutePermissionGuard routePath={routes.getSupportsParameter}>
            <HandleUpdateSupportParameter />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getEditSupportParameter,
        element: (
          <RoutePermissionGuard routePath={routes.getSupportsParameter}>
            <HandleUpdateSupportParameter />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getSupportsConsult,
        element: (
          <RoutePermissionGuard routePath={routes.getSupportsConsult}>
            <SupportsConsult />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getSupportsConsultDetail,
        element: (
          <RoutePermissionGuard routePath={routes.getSupportsConsult}>
            <DetailSupportsConsults />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getDispensarySupportFiles,
        element: (
          <RoutePermissionGuard routePath={routes.getDispensarySupportFiles}>
            <DispensarySupportFiles />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getDispensarySupportFilesDetail,
        element: (
          <RoutePermissionGuard routePath={routes.getDispensarySupportFiles}>
            <DetailDispensarySupportFiles />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getDispensaryStore,
        element: (
          <RoutePermissionGuard routePath={routes.getDispensaryStore}>
            <DispensaryStore />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getPendingConsults,
        element: (
          <RoutePermissionGuard routePath={routes.getPendingConsults}>
            <PendingConsults />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getPharmacyControl,
        element: (
          <RoutePermissionGuard routePath={routes.getPharmacyControl}>
            <PharmacyControl />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getPharmacyControlDetail,
        element: (
          <RoutePermissionGuard routePath={routes.getPharmacyControl}>
            <Delivery />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getConsumerOutReport,
        element: (
          <RoutePermissionGuard routePath={routes.getConsumerOutReport}>
            <ConsumerOutReport />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getTopInventoryOutReport,
        element: (
          <RoutePermissionGuard routePath={routes.getTopInventoryOutReport}>
            <TopInventoryOutReport />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getCancellationDeliveries,
        element: (
          <RoutePermissionGuard routePath={routes.getCancellationDeliveries}>
            <CancellationDeliveries />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getAccountingNotes,
        element: (
          <RoutePermissionGuard routePath={routes.getAccountingNotes}>
            <AccountingNotes />
          </RoutePermissionGuard>
        )
      },
      {
        path: routes.getAccountingNotesCreditDetail,
        element: (
          <RoutePermissionGuard routePath={routes.getAccountingNotes}>
            <AccountingNoteCreditDetail />
          </RoutePermissionGuard>
        )
      }
    ]
  }
]);

export default router;
